'use es6';

import { reorderExistingRichText } from './FormDragDrop';
import { getFormFieldGroups } from '../selectors/FormDefinition';
import createNewFormFieldGroup from 'forms-utils-lib/formFieldGroup/utils/createFormFieldGroup';
import { isEmpty } from 'underscore';
import { isRichTextInternalIdEqualFieldGroupInternalId } from 'FormsUI/utils/RichText';
export default (richTextId => (dispatch, getState) => {
  let skipNext = false;
  const groups = getFormFieldGroups(getState());
  const newGroups = groups.reduce((accum, group, index) => {
    if (skipNext) {
      skipNext = false;
      return accum;
    }
    if (!isRichTextInternalIdEqualFieldGroupInternalId(group, richTextId)) {
      return [...accum, group];
    }
    // Ungrouping
    if (!isEmpty(group.fields)) {
      const {
        richText
      } = group;
      return [...accum, createNewFormFieldGroup({
        richText
      }), Object.assign({}, group, {
        richText: {
          content: ''
        }
      })];
    }
    const nextGroup = groups[index + 1];
    skipNext = true;
    return [/* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
    ...accum, Object.assign({}, nextGroup, {
      richText: group.richText
    })];
  }, []);
  dispatch(reorderExistingRichText(newGroups));
});